<template>
    <div class="row">
        <div class="col-xs-12">
            <div>
                <img :src="team.banner_image_url" class="banner-img" />
            </div>
            <div class="lower-container">
                <div class="need-content">
                    <div class="text-center" v-if="team.posts.length === 0">
                        <h4 class="mt-50">
                            {{ team.name }} does not have any needs
                        </h4>
                    </div>
                    <div class="text-center" v-if="!selectedPost.id && metNeeds.length > 0">
                        <h4 class="mt-50">
                            There are no current needs
                        </h4>
                    </div>
                    <need v-if="windowSize('md')"
                          :need="selectedPost"
                          :preview="false"
                          :team="team"
                          :user-donated="userDonatedTime"
                          @donate="donate"
                          :is-most-recent="selectedPost && selectedPost.id === mostRecentUnmetId"></need>
                </div>
                <div class="org-container">
                    <div class="org-content">
                        <div class="team-content-container">
                            <div class="logo-container">
                                <img class="team-show-logo" :src="team.logo_image_url" />
                            </div>
                            <div class="team-content">
                                <div class="team-title">{{ team.name }}</div>
                                <div class="team-tagline" v-show="team.tagline">{{ team.tagline }}</div>
                                <div class="team-buttons">
                                    <button class="btn btn-primary btn-lg"
                                            id="followTeamModalButton"
                                            @click="followTeamOpenModal()">
                                        Follow
                                    </button>
                                    <a class="btn btn-warning"
                                       id="editTeamButton"
                                       :href="'/organization/' + team.slug"
                                       v-show="canEdit">
                                        Edit
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="team-description mt-20" v-show="team.description">
                            <div class="about-header">About</div>
                            <truncate-text :text="team.description" class="hidden-md hidden-lg"></truncate-text>
                            <span class="visible-md-inline visible-lg-inline">{{ team.description }}</span>
                        </div>
                        <need v-if="windowSize(null, 'md')"
                              :need="selectedPost"
                              :team="team"
                              :preview="false"
                              :user-donated="userDonatedTime"
                              @donate="donate"
                              :is-most-recent="selectedPost && selectedPost.id === mostRecentUnmetId"></need>
                        <div class="team-login text-muted" v-show="user === null">
                            Are you an admin for {{ team.name }}?
                            <a href="/login">Login Here</a>
                        </div>
                        <div class="other-needs-container">
                            <div class="other-needs-header">
                                <div class="other-needs-title">
                                    Other {{ showUnmetNeeds ? 'Unmet' : 'Met' }} Needs For {{ team.name }}
                                </div>
                                <div class="btn btn-default mt-20"
                                     v-show="metNeeds.length > 0 && unmetNeeds.length > 0"
                                     @click="showUnmetNeeds = !showUnmetNeeds">
                                    {{ showUnmetNeeds ? 'Show Met Needs' : 'Show Unmet Needs' }}
                                </div>
                            </div>
                            <div class="list-group mt-30 needs-list">
                                <a class="list-group-item need-list-item"
                                   v-for="need in activeNeeds"
                                   @click="postClicked(need)"
                                   :class="{'need-selected-item disabled': need.id === selectedPost.id}">
                                    <h4 class="list-group-item-heading" :class="{'need-met-item': need.post_status_id === 2 && need.id !== selectedPost.id}">
                                        {{ need.title | truncate(40) }}
                                    </h4>
                                    <p class="list-group-item-text">
                                        {{ need.description | truncate(200) }}
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <follow-team-modal :team="team" :open="followTeamOpenedAt"></follow-team-modal>
            <!-- TODO donations
            <need-donation-modal :need="donateNeed"
                                 :team="team"
                                 @hidden="needModalHidden"
                                 @donation-success="donationSuccess"></need-donation-modal>
             -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import FollowTeamModal from './components/FollowTeamModal';
    import TruncateText from '../../components/TruncatedText';
    import Need from '../../components/Need';
    import { phone, truncate } from '../../helpers/filters';
    import { windowSize } from '../../helpers/validators';

    export default {
        components: { FollowTeamModal, Need, TruncateText },
        data() {
            let team = {...window.Team};
            let selectedPost = {};
            if(window.PostId && Array.isArray(team.posts)) {
                selectedPost = team.posts.find(post => post.id === window.PostId) || {};
            }
            return {
                team,
                selectedPost,
                donateNeed: null,
                mostRecentUnmetId: null,
                user: window.User ? {...window.User} : null,
                showUnmetNeeds: true,
                incrementingClicks: false,
                postsClicked: [],
                followTeamOpenedAt: 0,
                userDonatedTime: null,
            }
        },
        computed: {
            canEdit() {
                return this.user &&
                    (
                        this.user.roles.some(role => role.slug === 'staff-super-admin') ||
                        this.user.teams.some(team => team.id === this.team.id)
                    );

            },
            metNeeds() {
                return this.team.posts.filter(post => {
                    /* TODO donations
                    if(post.accepts_donations) {
                        return post.donation_goal ? post.donations_net_total >= post.donation_goal : false;
                    }
                    */
                    return post.post_status_id === 2;
                });
            },
            unmetNeeds() {
                return this.team.posts.filter(post => {
                    /* TODO donations
                    if(post.accepts_donations) {
                        return post.donation_goal ? post.donations_net_total < post.donation_goal : true;
                    }
                    */
                    return post.post_status_id !== 2;
                });
            },
            activeNeeds() {
                return this.showUnmetNeeds ? this.unmetNeeds : this.metNeeds;
            }
        },
        methods: {
            windowSize,
            postClicked(post) {
                this.selectedPost = post;
                if(this.postsClicked.indexOf(post.id) < 0) {
                    axios.post('/post/click', { post_id: this.selectedPost.id, _token: window.csrf_token })
                        .then(() => {
                            this.postsClicked.push(post.id);
                        });
                }
            },
            followTeamOpenModal() {
                this.followTeamOpenedAt = (new Date()).getTime();
            },
            donate(need) {
                this.donateNeed = need;
            },
            needModalHidden() {
                this.donateNeed = null;
            },
            donationSuccess(need) {
                this.selectedPost = need;
                this.userDonatedTime = new Date().getTime();
                this.team.posts = this.team.posts.map(post => {
                    if(post.id === need.id) {
                        return need;
                    }
                    return post;
                })
            },
            setBrowserPreloads() {
                if(!this.team.posts.length) {
                    return;
                }
                for(const post of this.team.posts) {
                    for(const media of post.media) {
                        let preloadLink = document.createElement('link');
                        preloadLink.href = media.url;
                        preloadLink.rel = 'prefetch';
                        preloadLink.as = media.mime_type.startsWith('video/') ? 'video' : 'image';
                        document.head.appendChild(preloadLink);
                    }
                }
            }
        },
        filters: {
            phone,
            truncate
        },
        mounted() {
            setTimeout(() => {
                this.setBrowserPreloads();
            }, 1);
            if(!this.selectedPost || !this.selectedPost.id) {
                if(this.unmetNeeds.length) {
                    this.selectedPost = this.unmetNeeds[0];
                    this.mostRecentUnmetId = this.unmetNeeds[0].id;
                    return;
                }
                if(this.metNeeds.length) {
                    this.selectedPost = this.metNeeds[0];
                }
            }
            if(this.metNeeds.length > 0 && this.unmetNeeds.length === 0) {
                this.showUnmetNeeds = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .lower-container {
        width: 100%;
        margin-top: 20px;
        padding: 0 10px 0 10px;
        display: inline-flex;
        flex-wrap: wrap;
        @include media($md) {
            margin-top: 30px;
            padding: 0 30px 0 30px;
        }
    }

    .need-content {
        flex: 0 0 100%;
        order: 2;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        @include media($md) {
            order: 1;
            flex: 0 0 50%;
        }
        @include media($lg) {
            order: 1;
            flex: 0 0 60%;
        }
    }

    .org-container {
        flex: 0 0 100%;
        order: 1;
        display: inline-flex;
        justify-content: center;
        align-items: flex-start;
        @include media($md) {
            order: 2;
            flex: 0 0 50%;
        }
        @include media($lg) {
            order: 2;
            flex: 0 0 40%;
        }
    }

    .org-content {
        width: 100%;
        max-width: 500px;
    }

    .team-content-container {
        width: 100%;
        display: flex;
        margin-left: 20px;
        align-items: center;
        justify-content: center;
    }

    .logo-container {
        flex-shrink: 1;
    }

    .team-description {
        font-size: 14px;
        padding: 20px;
    }

    .team-login {
        font-size: 12px;
        padding: 20px;
    }

    .team-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 20px;
    }

    .team-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 175px;
        margin-top: 10px;
        height: auto;
        @include media($md) {
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            width: auto;
            height: 90px;
        }
    }

    .team-title {
        font-size: 20px;
        font-weight: 600;
    }

    .about-header {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .team-tagline {
        font-size: 15px;
    }

    .team-show-logo {
        width: 100px;
        height: auto;
        @include media($md) {
            width: 150px;
        }
        @include media($lg) {
            width: 200px;
        }
    }

    .banner-img {
        width: 100%;
    }

    .need-selected-item {
        color: $secondary !important;
    }

    .need-met-item {
        color: #60B764 !important;
    }

    .other-needs-header {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 30px;
        height: 50px;
    }

    .other-needs-title {
        font-size: 16px;
        font-weight: 600;
    }

    .need-list-item {
        cursor: pointer !important;
    }

    .needs-list {
        max-height: 800px;
        overflow-y: auto;
    }

    .other-needs-container {
        padding: 0 20px 0 20px;
        @include media($md) {
            padding: 0 60px 0 60px;
        }
        @include media($lg) {
            padding: 0 20px 0 20px;
        }
    }
</style>
